<template>
  <div
    class="custom-attribute--selector"
    :class="{ 'in-modal-form': inModalForm }"
  >
    <div
      v-on-clickaway="closeDropdown"
      class="label-wrap"
      @keyup.esc="closeDropdown"
    >
      <woot-button
        v-if="uiVersion === 'v1'"
        size="small"
        variant="link"
        icon="add"
        @click="toggleAttributeDropDown"
      >
        {{ $t(`${currentSection}.ADD_BUTTON_TEXT`) }}
      </woot-button>

      <woot-button
        v-else
        size="small"
        icon="add"
        color-scheme=""
        class-names="bg-[#efeeeb] button-outline"
        @click="toggleAttributeDropDown"
      >
        {{ $t(`${currentSection}.ADD_BUTTON_TEXT`) }}
      </woot-button>

      <div class="dropdown-wrap">
        <div
          :class="{ 'dropdown-pane--open': showAttributeDropDown }"
          class="dropdown-pane"
        >
          <custom-attribute-drop-down
            v-if="showAttributeDropDown"
            :attribute-type="attributeType"
            :contact-id="contactId"
            :init-custom-attributes="initCustomAttributes"
            @add-attribute="addAttribute"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomAttributeDropDown from './CustomAttributeDropDown.vue';
import alertMixin from 'shared/mixins/alertMixin';
import attributeMixin from 'dashboard/mixins/attributeMixin';
import { mixin as clickaway } from 'vue-clickaway';
import { BUS_EVENTS } from 'shared/constants/busEvents';

export default {
  components: {
    CustomAttributeDropDown,
  },
  mixins: [clickaway, alertMixin, attributeMixin],
  props: {
    attributeType: {
      type: String,
      default: 'conversation_attribute',
    },
    contactId: { type: Number, default: null },
    ticketId: { type: Number, default: null },
    uiVersion: {
      type: String,
      default: 'v1',
    },
  },
  data() {
    return {
      showAttributeDropDown: false,
    };
  },
  methods: {
    async addAttribute(attribute) {
      try {
        const {
          attribute_key: attributeKey,
          attribute_display_type: attributeDisplayType,
          default_value: attributeDefaultValue,
        } = attribute;
        const isCheckbox = attributeDisplayType === 'checkbox';
        const defaultValue = isCheckbox ? false : attributeDefaultValue || null;
        if (this.attributeType === 'conversation_attribute') {
          await this.$store.dispatch('updateCustomAttributes', {
            conversationId: this.conversationId,
            customAttributes: {
              ...this.customAttributes,
              [attributeKey]: defaultValue,
            },
          });
        } else if (this.inModalForm) {
          this.$emit('addAttribute', attributeKey, defaultValue);
          bus.$emit(BUS_EVENTS.FOCUS_CUSTOM_ATTRIBUTE, attributeKey);
          return;
        } else if (this.attributeType === 'ticket_attribute') {
          await this.$store.dispatch('tickets/update', {
            conversationId: this.conversationId,
            ticketId: this.ticketId,
            customAttributes: {
              ...this.customAttributes,
              [attributeKey]: defaultValue,
            },
          });
        } else {
          await this.$store.dispatch('contacts/update', {
            id: this.contactId,
            custom_attributes: {
              ...this.customAttributes,
              [attributeKey]: defaultValue,
            },
          });
        }
        bus.$emit(BUS_EVENTS.FOCUS_CUSTOM_ATTRIBUTE, attributeKey);
        this.showAlert(this.$t('CUSTOM_ATTRIBUTES.FORM.ADD.SUCCESS'));
      } catch (error) {
        const errorMessage =
          error?.response?.message ||
          this.$t('CUSTOM_ATTRIBUTES.FORM.ADD.ERROR');
        this.showAlert(errorMessage);
      } finally {
        this.closeDropdown();
      }
    },

    toggleAttributeDropDown() {
      this.showAttributeDropDown = !this.showAttributeDropDown;
    },

    closeDropdown() {
      this.showAttributeDropDown = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-attribute--selector {
  width: 100%;
  padding: var(--space-slab) var(--space-normal);

  .label-wrap {
    line-height: var(--space-medium);
    position: relative;

    .dropdown-wrap {
      display: flex;
      left: -1px;
      margin-right: var(--space-medium);
      position: absolute;
      top: var(--space-medium);
      width: 100%;

      .dropdown-pane {
        width: 100%;
        box-sizing: border-box;
      }
    }
  }
}

.error {
  color: var(--r-500);
  font-size: var(--font-size-mini);
  font-weight: var(--font-weight-medium);
}
</style>

<style lang="scss">
.custom-attribute--selector.in-modal-form {
  &,
  & > .label-wrap {
    display: inline;
    position: unset;
  }
  .label-wrap .dropdown-wrap {
    left: 0px;
  }
  .dropdown-pane {
    bottom: 30px;
    .items-start {
      height: auto;
    }
  }
}
</style>
